export default __webpack_public_path__ + "112a41dbf94e310b34a115739569c279.png";